<div class="email-dialog">

  <h2 mat-dialog-title class="dialog-header">
    <mat-icon class="header-icon">outgoing_mail</mat-icon>
    <span>Invia fattura via email</span>
  </h2>

  <mat-dialog-content>
    <p class="dialog-subtitle">Verrà inviata una copia PDF del documento al seguente indirizzo:</p>

    <!-- Email presente -->
    <div *ngIf="email_address" class="email-chip">
      <mat-icon class="email-chip-icon">mail</mat-icon>
      <span class="email-chip-text">{{ email_address }}</span>
    </div>

    <!-- Email assente -->
    <div *ngIf="!email_address" class="no-email-container">
      <mat-icon class="no-email-icon">mail_off</mat-icon>
      <p class="no-email-text">Nessun indirizzo email presente per questo cliente.</p>
      <button
        mat-stroked-button
        (click)="openCustomerPage()"
        class="goto-contact-button">
        <mat-icon>recent_actors</mat-icon>
        Vai al contatto
      </button>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="mt-3 dialog-actions">
    <button mat-button mat-dialog-close class="back-button">
      <mat-icon>arrow_back</mat-icon>
      Indietro
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!email_address"
      class="send-button">
      <mat-icon>send</mat-icon>
      Invia
    </button>
  </mat-dialog-actions>

</div>
